export const LOGOUT_REQUEST = 'LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'LOGOUT_FAILURE';

export const GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST';
export const GET_USER_DETAILS_SUCCESS = 'GET_USER_DETAILS_SUCCESS';
export const GET_USER_DETAILS_FAILURE = 'GET_USER_DETAILS_FAILURE';

export const ACCEPT_TERMS_AND_CONDITIONS_REQUEST =
  'ACCEPT_TERMS_AND_CONDITIONS_REQUEST';
export const ACCEPT_TERMS_AND_CONDITIONS_SUCCESS =
  'ACCEPT_TERMS_AND_CONDITIONS_SUCCESS';
export const ACCEPT_TERMS_AND_CONDITIONS_FAILURE =
  'ACCEPT_TERMS_AND_CONDITIONS_FAILURE';

export const CANCEL_TERMS_AND_CONDITIONS_REQUEST =
  'CANCEL_TERMS_AND_CONDITIONS_REQUEST';
export const CANCEL_TERMS_AND_CONDITIONS_SUCCESS =
  'CANCEL_TERMS_AND_CONDITIONS_SUCCESS';
export const CANCEL_TERMS_AND_CONDITIONS_FAILURE =
  'CANCEL_TERMS_AND_CONDITIONS_FAILURE';

export const GET_PRODUCT_INFORMATION_REQUEST =
  'GET_PRODUCT_INFORMATION_REQUEST';
export const GET_PRODUCT_INFORMATION_SUCCESS =
  'GET_PRODUCT_INFORMATION_SUCCESS';
export const GET_PRODUCT_INFORMATION_FAILURE =
  'GET_PRODUCT_INFORMATION_FAILURE';

const initialState = {
  isLoading: false,
  userDetail: null,
  error: '',
  status: '',
  action: '',
  link: '',
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    // Logout cases.
    case LOGOUT_REQUEST:
      return {
        ...state,
        error: '',
        status: '',
        isLoading: true,
        action: '',
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userDetail: null,
        status: action.payload.status,
        action: action.payload.action,
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
        action: '',
      };

    // Get user detail case.
    case GET_USER_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: '',
        status: '',
        action: '',
        userDetail: null,
      };
    case GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        userDetail: action.payload,
        status: 'success',
      };
    case GET_USER_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        status: 'failure',
        error: `${action.payload.code} - ${action.payload.message}`,
      };

    // product info
    case GET_PRODUCT_INFORMATION_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case GET_PRODUCT_INFORMATION_SUCCESS:
      return {
        ...state,
        userDetail: action.payload,
        isLoading: false,
        status: 'success',
      };
    case GET_PRODUCT_INFORMATION_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isLoading: false,
        status: 'failure',
      };

    // terms n conditions
    case ACCEPT_TERMS_AND_CONDITIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case ACCEPT_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        userDetail: action.payload,
        isLoading: false,
        status: 'success',
      };
    case ACCEPT_TERMS_AND_CONDITIONS_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isLoading: false,
        status: 'failure',
      };

    case CANCEL_TERMS_AND_CONDITIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CANCEL_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        userDetail: action.payload,
        isLoading: false,
        status: 'success',
      };
    case CANCEL_TERMS_AND_CONDITIONS_FAILURE:
      return {
        ...state,
        error: `${action.payload.code} - ${action.payload.message}`,
        isLoading: false,
        status: 'failure',
      };

    default:
      return state;
  }
};

export default loginReducer;
